import type { MagazineSection } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

export default function integrityCheck(
    sections: MagazineSection[]
): IntegrityStatus {
    const errors: IntegrityStatus = [];

    sections.forEach((section) => {
        errors.push(
            ...checkItemArrayIntegrity(section.items, ["id", "url", "headline"])
        );
    });

    return errors;
}
